import { useSessionStore } from '@/stores/SessionStore'
import { useCachedFetch } from '@/composables/useFetch'
import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals();

export const useApiGeoInfo = () => {
  async function getGeoInfo(options) {
    const sessionStore = useSessionStore();

    const params = {
      ...options,
      wf_token: sessionStore.token
    }

    const queryString = new URLSearchParams(params).toString()
    const url = `${$BASEURL}/common/getGeoInfo?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      return {error, data}
    } catch (error) {
      console.warn(error)

      return error
    }
  }

  async function byLatLon(lat, lon) {

    const params = {
      lat: lat,
      lon: lon,
    }

    return await getGeoInfo(params);
  }

  async function bySearch(searchTerm) {

    const params = {
      search: searchTerm,
    }

    return await getGeoInfo(params);
  }

  return {
    byLatLon,
    bySearch
  }
}
